"use client"

import { useMusicContext } from "@/context/musicContext"
import PlayButton from "@/components/buttons/PlayButton"

export default function MusicControlBox() {
  const {
  previousSong,
  nextSong,
  currentTrackData,
} = useMusicContext()

const isRadio = currentTrackData?.type === "radio"

  return (
    <div className="flex items-center justify-center gap-1 w-full">
      {/* ANTERIOR */}
      {!isRadio && (
        <button
          className="flex h-6 w-6 p-6 rounded-full active:scale-95 items-center justify-center"
          onClick={previousSong}
        >
          <i className="bx bx-skip-previous text-[3rem] text-white/80" />
        </button>
      )}

      {/* PLAY / PAUSE */}
      <PlayButton />

      {/* SIGUIENTE */}
      {!isRadio && (
        <button
          className="flex h-6 w-6 p-6 rounded-full active:scale-95 items-center justify-center"
          onClick={nextSong}
        >
          <i className="bx bx-skip-next text-[3rem] text-white/80" />
        </button>
      )}

    </div>
  )
}